import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DashTabs from "./DashTabs";
import DashTable from "./DashTable";
import CustomerDetails from "./CustomerDetails";
import { Col, Container, Row } from "react-bootstrap";
import { Button } from "@mui/material";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { filterByValue } from "../../../utils";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { useGetUserManagementsQuery } from "../../../Service/userManagment";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import DateRangePicker from "../../../Component/DigitalMarketing/Forms/DateRangePicker";
import Dropdown from "../../../Component/DigitalMarketing/Forms/Dropdown";
import PermissionCheck from "../../../Component/PermissionCheck";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import moment from "moment";
const initialUser = {
  fullName: "",
  email: "",
  password: "",
  phoneNumber: "",
  roleId: null,
  profileImage: "",
  activeStatus: 1,
};
function UsersManagement() {
  const [show, setshow] = useState(false);
  const [user, setUser] = useState(initialUser);
  const initialstate = {
    startDate: null,
    endDate: null,
  };
  const [date, setDate] = useState(initialstate);
  const [dateRange, setDateRange] = useState(initialstate);
  const [pagination, setpagination] = useState(1);
  const [paramsValue, setParamsValue] = useState({
    date: initialstate,
  });
  const [show1, setShow1] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { open, message, openSnackBar, type } = useSnackbar();
  const [filteredUsers, setFilteredUsers] = useState(null);
  const dispatch = useDispatch<any>();
  const pagi = {
    pageNo: pagination,
    // date: paramsValue?.date,
    // filter: filter,
    name: searchValue,
  };
  const { data: users, refetch,isLoading }: any = useGetUserManagementsQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    const data: any = {
      first: "Users",
    };
    dispatch(Change(data));
  }, [dispatch]);

  const onSearch = (val) => {
    if (users) setFilteredUsers(filterByValue(users, val));
  };
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      setDate({
        startDate: moment(value[0]).format("DD-MM-YYYY"),
        endDate: moment(value[1]).format("DD-MM-YYYY"),
      });
      setDateRange(value);
    } else{
      setSearchValue(event.target.value);
    }
  };
  const ListFilter = () => {
    setParamsValue({
      date,
      // name: searchValue,
    });
    setShow1(true);
    setpagination(1)
  };
  const ClearFilter = () => {
    setShow1(false);
    setDate(initialstate);
    setDateRange(initialstate);
    setParamsValue({ date: initialstate});
    setSearchValue("")
  };
  return (
    <React.Fragment>
      <Container fluid>
        <Toast open={open} type={type} message={message} />
        <Row className="mb-3">
          <Col md={5} className="mb-3">
            <SearchBox
              value={searchValue}
              onChange={(event) => onHandleChange(event)}
            />
          </Col>
          <Col md={7} className="d-flex mb-3 justify-content-between">
            {/* <DateRangePicker
              date={dateRange}
              key_name="date"
              handleChange={onHandleChange}
            />{" "} */}
            {/* {!show1 ? (
              <div className="clear-filter f-14 mx-2 cursor">
                <Button variant="contained" onClick={ListFilter} id="btn-add">
                  {" "}
                  Filter
                </Button>
              </div>
            ) : (
              <p
                className="clear-filter f-14 mb-0 mt-1 mx-2 cursor"
                onClick={ClearFilter}
              >
                X Clear filters
              </p>
            )} */}
          </Col>
        </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <Button
              variant="contained"
              id="btn"
              onClick={() => {
                setshow(!show);
                setUser(initialUser);
              }}
            >
              {show ? "x  Close" : "+ Add User"}                
            </Button>
          </div>

        <div className="grid-container">
          <div className={show ? "item1" : "item1-full"}>
            <DashTable
              show={show}
              users={filteredUsers ? filteredUsers : users?.data}
              setUser={setUser}
              isLoading={isLoading}
              refetch={refetch}
              setshow={setshow}
            />
             {!isLoading &&<Pagination
              setpagination={setpagination}
              pagination={pagination}
              data={users}
            />}
          </div>
          {show ? (
            <div className="Customer-details mx-3 item2">
              <ul className="md-bord">
                <CustomerDetails
                  user={user}
                  openSnackBar={openSnackBar}
                  cancel={
                    <Button
                      variant="contained"
                      className="me-2"
                      id="btn-cancel"
                      onClick={() => {
                        setshow(!show);
                        setUser(initialUser);
                      }}
                    >
                      Cancel
                    </Button>
                  }
                  show={show}
                  setshow={setshow}
                />
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
      </Container>
    </React.Fragment>
  );
}

export default React.memo(UsersManagement);
